import React from "react";

const SessionExpired = (props) => {
  return (
    <>
      <nav
        className="navbar navbar1 navbar-expand-lg navbar-light bg-light wow fadeInDown"
        data-wow-delay=".2s"
        data-wow-duration="0.7s"
        data-cy="navbar"
      >
        {/* <button type="button" id="sidebarCollapse" className="btn btn-info" data-cy="menu-icon">
                    <img src={process.env.PUBLIC_URL + "/assets/images/icons/menu.png"} alt="menu-icon" />
                </button> */}
        <ul className="navbar-nav mr-auto"></ul>
        <div className="jiologo" data-cy="brand-logo">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/new-jio-logo.svg"}
            alt="jio-logo"
          />
        </div>
        <div data-cy="settings-icon">
          {/* <button className="btn btn-sm bg-light text-white" type="button" id="slideFilters" aria-expanded="false" aria-controls="collapseExample">
                        <i className="fa fa-2x fa-cog " aria-hidden="true"></i>
                    </button> */}
        </div>

        {/* <ul className="userdropdown" data-cy="user-dropdown">
          <li className="dropdown">
            <ul className="dropdown-menu">
              <li>
                <a
                  href="https://sitohs.jio.com:4443/oam/server/logout?end_url=https://pcsit.jioconnect.com:7701/c/portal/logout"
                  className="nobor"
                >
                  Sign Out{" "}
                </a>
              </li>
            </ul>
          </li>
        </ul> */}
      </nav>
      <br />
      <div style={{ marginTop: 50 }}>
        <h1 className="unAuthorisedHeading">{"Session Expired"}</h1>
        <h2 className="unAuthorisedText">
          <a href={window.REACT_APP_ENTRY_URL}>{"go back"}</a>
        </h2>
      </div>
    </>
  );
};

export default SessionExpired;
